<template>
	<div class="radio-field-wrapper">
		<div v-for="(item, idx) in items"
			:key="idx"
			v-if="item"
			class="item"
			:class="{ 'selected': Value && (Value === item || Value.id === item.id) }"
			@click="onClickItem(item)">
			<div class="choice" />
			<span class="text">{{ item.name | ftc }}</span>
		</div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'radioListComponent',

	//=========================================================================
	props: [
		'title',
		'required',
		'value',
		'items',
		'disabled'
	],

	//=========================================================================
	data() {
		return {
			Value: null
		}
	},

	//=========================================================================
	created() {
		this.Init()
	},

	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		Init() {
			if (this.disabled) return

			this.Value = null

			let _firstItem = null
			if (this.items && this.items.length)
			{
				this.items.some(item => {
					if (!_firstItem) _firstItem = item
					if (this.value === String(item.id))
					{
						this.Value = item
						return true
					}
				})
			}

			if (_firstItem && !this.Value)
				this.Value = _firstItem

			if (this.Value && this.Value.id)
				this.$emit('startData', String(this.Value.id))

			this.$emit('input', this.Value && this.Value.id ? String(this.Value.id) : null)
		},

		//---------------------------------------------------------------------
		onClickItem(val) {
			if (this.disabled) return

			this.Value = val
			this.$emit('input', this.Value && this.Value.id ? String(this.Value.id) : null)
		}

		//---------------------------------------------------------------------
	},

	//=========================================================================
	watch: {
		'items': function(items, old) {
			if (!Helper.arrayCompare(items, old))
				this.Init()
		},
		'value': function(val) {
			this.Init()
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.radio-field-wrapper {
    display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: start;
	-webkit-justify-content: start;

	align-items: flex-start;
	-webkit-align-items: flex-start;
}

.radio-field-wrapper > .item {
	position: relative;

    display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: start;
	-webkit-justify-content: start;

	align-items: center;
	-webkit-align-items: center;

	height: 45px;
	margin-right: 40px;
	font-weight: 400;
	cursor: pointer;
}

.radio-field-wrapper > .item > .choice {
	position: relative;
	flex: 0 26px;
	-webkit-flex: 0 26px;
    width: 26px;
    height: 26px;
    margin-right: 10px;
    border-radius: 50%;
    background: #CDD1DA;
    box-shadow: inset 0 2px 3px rgba(0,0,0,.2);
    transition: all .2s;
    cursor: pointer;
}

.radio-field-wrapper > .item > .text {
	flex: 1 0;
	-webkit-flex: 1 0;
	line-height: 1;
}

.radio-field-wrapper > .item > .choice:before {
	content: '';
	position: absolute;
    display: inline-block;
    width: 16px;
    height: 16px;
    top: 5px;
    left: 5px;
    border-radius: 50%;
    background-color: #f6f6f6;
    box-shadow: 0 2px 5px rgba(0,0,0,.3);
    transition: all .2s;
}

.radio-field-wrapper > .item.selected > .choice {
	background-color: #2c8ad8;
}
.w5-application.mc .radio-field-wrapper > .item.selected > .choice {
	background-color: #01196f;
}
.radio-field-wrapper > .item.selected > .choice:before {
	background-color: white;
}




.radio-field-wrapper.smaller {
	width: 100%;
	justify-content: space-between;
	-webkit-justify-content: space-between;
}

.radio-field-wrapper.smaller > .item {
	height: auto;
	margin-right: 30px;
}

.radio-field-wrapper.smaller > .item > .text {
	font-size: 10px;
	font-weight: 500;
}

.radio-field-wrapper.smaller > .item > .choice {
	flex: 0 16px;
	-webkit-flex: 0 16px;
    width: 16px;
    height: 16px;
}

.radio-field-wrapper.smaller > .item > .choice:before {
    width: 8px;
    height: 8px;
    top: 4px;
    left: 4px;
}


@media (max-width: 767px) {
	.radio-field-wrapper {
		height: auto;
		flex-direction: column;
	}
	.radio-field-wrapper.smaller {
		flex-wrap: wrap;
		flex-direction: row;
	}
	.radio-field-wrapper.smaller > .item {
		width: 30%;
		margin-right: 0;
		margin-bottom: 10px;
	}
	.radio-field-wrapper.smaller > .item > .choice {
		margin-right: 4px;
	}
}
</style>



// WEBPACK FOOTER //
// radio.vue?5a2388c8